import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { Command } from 'cmdk';
import { BANG_SEARCH_QUERY_MAP, SEARCH_BANG_OPTIONS, SEARCH_BANGS, DEFAULT_SEARCH_QUERY } from "@/constants/searchBang.constant";
import { getBang, getBangData } from "@/utils/searchBang.util";
import "./SearchView.scss";
import { useSearchStore } from "@/store/useSearchStore";
const SearchView = () => {
    const [searchQuery, setSearchQuery] = useState("");
    const [options, setOptions] = useState(SEARCH_BANG_OPTIONS);
    const [bang, setBang] = useState("");
    const [isOpen, setOpen] = useState(false);
    const { setInputValue } = useSearchStore();
    const searchInput = useRef(null);
    useEffect(() => {
        const handleShortcut = (event) => {
            const isMac = navigator.platform.toUpperCase().includes("MAC");
            if (event.key.toLowerCase() === "j" &&
                ((isMac && event.metaKey) || (!isMac && event.ctrlKey))) {
                event.preventDefault();
                searchInput.current?.focus();
            }
        };
        window.addEventListener("keydown", handleShortcut);
        return () => {
            window.removeEventListener("keydown", handleShortcut);
        };
    }, []);
    const handleEnterKey = () => {
        if (SEARCH_BANGS.includes(bang)) {
            window.open(BANG_SEARCH_QUERY_MAP[bang] + searchQuery.replace(bang, ""), "_blank");
        }
        else {
            window.open(DEFAULT_SEARCH_QUERY + searchQuery, "_blank");
        }
        onDialogClose();
    };
    const onValueChange = (query) => {
        const bang = getBang(query);
        const bangData = getBangData(bang);
        let filteredOptions = [];
        if (!bangData) {
            filteredOptions =
                (query ?? "").length > 0
                    ? SEARCH_BANG_OPTIONS.filter((item) => {
                        return item.bang.toLowerCase().startsWith(query.toLowerCase());
                    })
                    : SEARCH_BANG_OPTIONS;
        }
        if (filteredOptions.length === 0) {
            filteredOptions.push({
                label: `${bangData?.label || "Ecosia Search"}: ${bangData?.label ? query.replace(bang, "") : query}`,
                icon: bangData?.icon,
            });
        }
        setSearchQuery(query);
        setOptions(filteredOptions);
        setBang(bang);
        setInputValue(query);
    };
    const onDialogClose = () => {
        setOpen(false);
        setBang("");
        onValueChange("");
    };
    return (_jsx(_Fragment, { children: _jsxs(Command, { className: " border-0 bg-transparent w-full search-view-parent rounded-xl box-shadow shadow-none bg-white", shouldFilter: false, children: [_jsx("div", { className: "search-view-container w-full rounded-xl", children: _jsx(Command.Input, { placeholder: "Search anything...", value: searchQuery, onValueChange: onValueChange, onFocus: () => setOpen(true), onBlur: () => setOpen(false), ref: searchInput, className: "content text-left  w-full px-3 py-2 outline-none leading-10 text-black rounded-xl text-lg" }) }), isOpen && _jsx(Command.List, { className: "max-h-[200px] mt-3 bg-white h-fit !min-h-[0] overflow-y-auto rounded-xl  hide-scrollbar", children: _jsx(Command.Group, { children: options.map((option) => (_jsxs(Command.Item, { className: "flex cursor-pointer items-center rounded px-2 py-2 text-base text-black hover:bg-primary hover:bg-opacity-25 aria-selected:bg-primary aria-selected:bg-opacity-25", onSelect: () => {
                                if (option.bang) {
                                    onValueChange(option.bang + " ");
                                    searchInput.current?.focus();
                                }
                                else {
                                    handleEnterKey();
                                }
                            }, value: option.label.trim() + "1", children: [option.icon && option.icon, _jsx("span", { className: "ps-3 pe-2", children: option.label }), option.bang && (_jsxs("div", { className: "font-semibold", children: ["(", option.bang, ")"] }))] }))) }) })] }) }));
};
export default SearchView;
